<template>
  <exercise-logic
    exCollection="blocksExCollection"
    @ready="onReady"
    @error="onError"
    @saved="onSaved"
    @savedNext="onSavedNext"
    @loadedEx="onLoadedEx"
    @loadedRefs="onLoadedRefs"
    :doc="doc"
    :shared="false"
  >
    <template slot-scope="{ saveExercise }">
      <v-row>
        <v-col cols="4" class="mb-4">
          <h2 class="headline" v-text="$t('exercise_blocks.step1.title')"></h2>
        </v-col>
        <v-col cols="8" lg="6" class="mb-4">
          <p
            v-for="(item, index) in $t('exercise_blocks.step1.description')"
            :key="index"
            v-text="item"
          />
           <p
            v-for="(item, index) in $t('exercise_blocks.step1.list')"
            :key="`p-${index}`"
            v-text="item"
          />
        </v-col>
      </v-row>
      <v-row v-if="doc">
        <v-col cols="4">
          <unit-text-area
            v-model="doc.box1"
            :props="{ title: '1' }"
            color="amber"
            theme="light"
            bgColor="#303030"
          >
          </unit-text-area>
        </v-col>
        <v-col cols="4">
          <unit-text-area
            v-model="doc.box2"
            :props="{ title: '2' }"
            color="amber"
            theme="light"
            bgColor="#303030"
          >
          </unit-text-area>
        </v-col>
        <v-col cols="4">
          <unit-text-area
            v-model="doc.box3"
            :props="{ title: '3' }"
            color="amber"
            theme="light"
            bgColor="#303030"
          >
          </unit-text-area>
        </v-col>
        <v-col cols="4">
          <unit-text-area
            v-model="doc.box4"
            :props="{ title: '4' }"
            color="amber"
            theme="light"
            bgColor="#303030"
          >
          </unit-text-area>
        </v-col>
        <v-col cols="4">
          <unit-text-area
            v-model="doc.box5"
            :props="{ title: '5' }"
            color="amber"
            theme="light"
            bgColor="#303030"
          >
          </unit-text-area>
        </v-col>
        <v-col cols="4">
            <unit-text-area
              v-model="doc.box6"
              :props="{ title: '6' }"
              color="amber"
              theme="light"
              bgColor="#303030"
            >
            </unit-text-area>
          </v-col>
      </v-row>
      <bottom-navigation
        :save="true"
        :next="false"
        :prev="false"
        :gridView="false"
        :gridToggle="false"
        @save="saveExercise"
        @prev="prevStep"
        @next="saveExercise(false)"
      >
      </bottom-navigation>

      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title
            class="headline"
            v-text="$t('exercise_service.saved.title')"
          ></v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="amber" text @click="closeDialog">
              Close
            </v-btn>

            <v-btn
              color="amber accent-1"
              text
              :to="`/users/project/${$route.params.id}`"
            >
              Back to Project
            </v-btn>
            <v-btn color="amber accent-1" text to="/users/dashboard">
              Back to Dashboard
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </exercise-logic>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogic } from "@/components/exercises";
import { UnitTextArea } from "@/components/units";

// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserBlock",
  data() {
    return {
      e1: 1,
      doc: {
        box1: [],
        box2: [],
        box3: [],
        box4: [],
        box5: [],
        box6: [],
      },
      tabs: [{ title: "Building Blocks", count: 1 }],
      userSelected: null,
      debug: false,
      dialog: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogic,
    UnitTextArea,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },

  mounted() {},
  methods: {
    nextStep() {
      this.e1++;
      // this.saveExercise(false);
    },
    prevStep() {
      this.e1--;
      // this.saveExercise(false);
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved");
      this.dialog = true;
    },
    onLoadedRefs(refs) {
      console.log("loaded", refs);
    },
    onLoadedEx(ex) {
      this.doc = ex.doc;
      this.exercise = ex;
    },
    onSavedNext() {
      this.nextStep();
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>
